module.exports = __webpack_public_path__ + "img/choose-shape-2.0b51f673.png";